// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon":"gCC3oi","panelContainer":"-Emr1P","title":"_1zKPwh","generateOutlineAttributes":"_1JzTTU","body":"_1GY9_B","reducedPadding":"_2HCtzZ"};